<template>
    <div class="configure-cart-item-name">
        <b-field>
            <b-input
                :placeholder="$t('checkout.configure.inputLabels.objectName')"
                v-model.trim="fileName"
            ></b-input>
        </b-field>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ConfigureFileName',
    props: {
        printFileId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters(['printFileById']),
        fileName: {
            get() {
                return this.printFile.name;
            },
            set(value) {
                this.$store.dispatch('update3DFile', {
                    id: this.printFileId,
                    name: value,
                });
            },
        },
        printFile() {
            return this.printFileById(this.printFileId);
        },
    },
};
</script>
